var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClipBoard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 55C42.9117 55 55 42.9117 55 28C55 13.0883 42.9117 1 28 1C13.0883 1 1 13.0883 1 28C1 42.9117 13.0883 55 28 55Z",
    stroke: "#FF3097",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0906 14.0908H25.5451C24.3401 14.0908 23.3633 15.0677 23.3633 16.2726V17.3635C23.3633 18.5685 24.3401 19.5454 25.5451 19.5454H32.0906C33.2955 19.5454 34.2724 18.5685 34.2724 17.3635V16.2726C34.2724 15.0677 33.2955 14.0908 32.0906 14.0908Z",
    stroke: "#FF3097",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8178 16.2727H38.0906C38.6692 16.2727 39.2242 16.5026 39.6333 16.9117C40.0424 17.3209 40.2724 17.8759 40.2724 18.4545V40.2727C40.2724 40.8513 40.0424 41.4064 39.6333 41.8155C39.2242 42.2246 38.6692 42.4545 38.0906 42.4545H19.5451C18.9664 42.4545 18.4115 42.2246 18.0023 41.8155C17.5932 41.4064 17.3633 40.8513 17.3633 40.2727V18.4545C17.3633 17.8759 17.5932 17.3209 18.0023 16.9117C18.4115 16.5026 18.9664 16.2727 19.5451 16.2727H22.8178",
    stroke: "#FF3097",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClipBoard);
export default __webpack_public_path__ + "static/media/IconClipBoard.5b98c7826678125836daf9408d6b2a28.svg";
export { ForwardRef as ReactComponent };